import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Terms = () => {
  const [termsContent, setTermsContent] = useState('');

  useEffect(() => {
    // Fetch data from the API
    fetch('https://dayoffice24.it/api/terms-and-condition')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        console.log(data); // Log the API response to check its format
        if (data.success && data.data && data.data.length > 0) {
          setTermsContent(data.data[0].description);
        } else {
          throw new Error('API returned an error: No terms and conditions data found.');
        }
      })
      .catch((error) => {
        console.error('Error fetching terms and conditions data:', error);
      });
  }, []);

  return (
    <div className="main_wrap">
      <Header />

      <div className="content-wrapper">
        <div class="breadcrumb-wrap bg-f br-2">
          <div class="container">
            <div class="breadcrumb-title text-center">
              <h2>Terms & Conditions</h2>
              <ul class="breadcrumb-menu list-style">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>Terms & Conditions</li>
              </ul>
            </div>
          </div>
        </div>

        <section class="terms-wrap pt-100 pb-75 mb-10">
          <div class="container">
            <div class="row gx-5">
              <div class="col-lg-12">
                {termsContent && (
                  <div dangerouslySetInnerHTML={{ __html: termsContent }} />
                )}
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Terms;
